export default "__VITE_ASSET__DD4$KBLD__"